<template>
  <div>&nbsp;</div>
</template>

<script>
export default {
  name: 'loginLiteToken',
  mounted () {
    this.executeLogin()
  },
  methods: {
    async executeLogin () {
      let urlHash = window.location.hash
      if (urlHash !== null && urlHash !== undefined && urlHash.length > 0) {
        const indicePontoInterrogacao = urlHash.indexOf('?')
        if (indicePontoInterrogacao === -1) {
          return false
        }
        urlHash = urlHash.substring(indicePontoInterrogacao)
        const urlParams = new URLSearchParams(urlHash)
        let token = urlParams.get('token')
        token = (token === undefined || token === null ? '' : token.trim())

        try {
          const payload = {
            token: token
          }
          const resposta = await this.axios.post('manager/auth/lite/token', payload)
          const urlProduto = resposta.data.url_login
          window.location.href = urlProduto
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
}
</script>
